import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { apiList, getApiUrl } from 'src/app/core/Constants/apiList';
import { ApiResponse, City, Country, Currency, ProviderTypeList, Regulator, SpecialityTypeList, State } from 'src/app/core/Models/interfaces/responseData';
import { UtilityService } from 'src/app/core/Services/utility.service';
import { of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { UserService } from 'src/app/core/Services/user.service';
import { USER_TYPE } from 'src/app/core/Constants/static';

@Injectable({
  providedIn: 'root'
})
export class ProvPayerApiService {
  public currencyList: Currency[] = [];
  public countryList: Country[] = [];
  public stateList: State[] = [];
  public regulatorList: Regulator[] = [];
  public cityList: City[] = [];
  user: any;
  constructor(private http: HttpClient,
    private utility: UtilityService,
    private userService: UserService) {
    this.user = userService.getUserInfo();
  }
  providerType:ProviderTypeList[] = [];
  specialityType:SpecialityTypeList[] = [ ];


  payerReg(data: any): Observable<any> {
    let endpoint = getApiUrl(apiList.insurance.payerRegistration);
    return this.http.post<ApiResponse>(endpoint, data);
  }
  getPayerList(){
    const url = getApiUrl(apiList.insurance.listing)
    return this.http.get<ApiResponse>(url);
  }
  providerReg(data: any): Observable<any> {
    let endpoint = getApiUrl(apiList.provider.provRegistration);
    return this.http.post<ApiResponse>(endpoint, data);
  }
  checkUserExist(username:any): Observable<any>{
    let endpoint = getApiUrl(apiList.insurance.userExist);
    return this.http.post<ApiResponse>(endpoint, username);
  }
  addMasterDrug(payload:any): Observable<any>{
    let endpoint = getApiUrl(apiList.drugList.addMasterDrug);
    return this.http.post<ApiResponse>(endpoint,payload);
  }
  getInsuranceList(payLoad?: any) {
    const url = getApiUrl(apiList.insurance.listing,payLoad,null)
    return this.http.get<ApiResponse>(url);
  }
  getInsuranceListByPayer(id:any,payLoad?: any){
    const url = getApiUrl(apiList.insurance.payerListing,payLoad,{id})
    return this.http.get<ApiResponse>(url);
  }
  getProviderList(payLoad?: any) {
    let queryParam = this.utility.objectToURLParam(payLoad);
    const url = getApiUrl(apiList.provider.listing) + queryParam;
    return this.http.get<ApiResponse>(url);
  }
  getProviderListByProvider(id:any,payLoad?: any){
    const url = getApiUrl(apiList.provider.providerListing,payLoad,{id})
    return this.http.get<ApiResponse>(url);
  }
  getVersionList(payLoad:any){
    const url = getApiUrl(apiList.drugList.versionlist,payLoad);
    return this.http.get<ApiResponse>(url);
  }
  getPreferredList(payLoad:any,id:any){
    const url = getApiUrl(apiList.drugList.preferredList,payLoad,{id});
    return this.http.get<ApiResponse>(url);
  }
  saveEditProviderDetails(id: any, payLoad: any) {
    let endpoint = getApiUrl(apiList.provider.saveEditProviderDetails, null, { id });
    return this.http.put<any>(endpoint, payLoad)
  }
  regenerateClientSecret(id:any){
    let endpoint = getApiUrl(apiList.insurance.regenerateClientSecret)+'/'+`${id}`;
    return this.http.put<any>(endpoint,null);
  }
  getCountryList() {
    if (!this.countryList?.length) {
      let endpoint = getApiUrl(apiList.insurance.countryList);
      return this.http.get<ApiResponse>(endpoint).pipe(
        map(res => res.data),
        tap(data => {
          this.countryList = data;
        })
      );
    }
    return of(this.countryList);
  }
  getCurrencyList() { 
    if (!this.currencyList.length) {
      let endpoint = getApiUrl(apiList.insurance.currencyList);
      return this.http.get<ApiResponse>(endpoint).pipe(
        map(res => res.data),
        tap(data => {
          this.currencyList = data;
        })
      );
    }
    return of(this.currencyList);
  }
  getRegulatorList() {
    if (!this.regulatorList.length) {
      let endpoint = getApiUrl(apiList.insurance.regulatorList);
      return this.http.get<ApiResponse>(endpoint).pipe(
        map(res => res.data),
        tap(data => {
          this.regulatorList = data;
        })
      );
    }
    return of(this.regulatorList);
  }

  getLanguageList() {
    let endpoint = getApiUrl(apiList.insurance.languageList);
    return this.http.get<ApiResponse>(endpoint);
  }
  getStateList(id: number) {
    let endpoint = getApiUrl(apiList.insurance.stateList, null, { id });
    return this.http.get<ApiResponse>(endpoint);
  }
  getEditProviderDetails(id: any) {
    let endpoint = getApiUrl(apiList.provider.getEditProviderDetails, null, { id });
    return this.http.get<any>(endpoint)

  }
  getCityList(stateId: number) {
    let endpoint = getApiUrl(apiList.insurance.city, null, { id: stateId });
    return this.http.get<any>(endpoint)
  }
  getPhoneCodes(){
    let endpoint = getApiUrl(apiList.insurance.phoneCodes);
    return this.http.get<any>(endpoint)
  }
  updateVersion(id:any,payLoad:any){
    let endpoint = getApiUrl(apiList.drugList.updateVersion, null, { id });
    return this.http.put<any>(endpoint, payLoad);
  }
  updatePrefferedDrug(PayerPreferredDrugId:any,payLoad:any){
    let endpoint = getApiUrl(apiList.drugList.updatePreffered, null, { PayerPreferredDrugId });
    return this.http.put<any>(endpoint, payLoad);
  }
  downLoadTemplate(){
    let endpoint = getApiUrl(apiList.drugList.downloadTemplate);
    return this.http.get(endpoint,{ headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }, responseType: 'blob', observe: 'response' });
    
  }

  getProviderTypeList(){
    if (!this.providerType.length) {
      let endpoint = getApiUrl(apiList.provider.providerTypeListing);
      return this.http.get<ApiResponse>(endpoint).pipe(
        map(res => res.data),
        tap(data => {
          this.providerType = data;
        })
      );
    }
    return of(this.providerType);

  }
  getSpecialityTypeList(){
    if (!this.specialityType.length) {
      let endpoint = getApiUrl(apiList.provider.specialityTypeLIsting);
      return this.http.get<ApiResponse>(endpoint).pipe(
        map(res => res.data),
        tap(data => {
          this.specialityType = data;
        })
      );
    }
    return of(this.specialityType);

  }
}
